export default maxValue => value => value > maxValue ? `Max value is ${maxValue}`: undefined
